import { registerNotificationScope } from '@ayocore/platform/notifications/client';

export const CRM_LEADS_NOTIFICATION_SCOPE = 'crm:leads';

/** CRM владеет областью раздела; инстансы создают уведомления с типом сущности лида. */
export function registerCrmNotificationScopes(): void {
  registerNotificationScope({
    code: CRM_LEADS_NOTIFICATION_SCOPE,
    match: marker => marker.entity_type === 'crm::LeadRepository',
  });
}
